import React, { useState, useEffect, useRef } from "react";
import "./HoleOfFame.css";
import LoadingPage from '../../../Error/LoadingPage/LoadingPage';
import { useNavigate } from "react-router-dom";
import API from "../../../Functions/API/api";

const HallOfFame = () => {
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate()
  // Dropdown state
  const [openMenuId, setOpenMenuId] = useState(null);
  const menuRef = useRef();

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const res = await API.get(
          `/Student/leaderboard?page=${page}&limit=10`
        );
        setUsers(res.data.users);
        setTotalPages(res.data.totalPages);
      } catch (err) {
        setError("Failed to load leaderboard.");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [page]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenuId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (loading) return <LoadingPage />;
  if (error) return <div className="hall-container"><h1>🏆 Hall of Fame</h1> <p className="error">{error}</p></div>;

  const handleBan = async (userId) => {
    try {
      await API.post(`/admin/ban/${userId}`);
      alert("User banned successfully!");
      setOpenMenuId(null);
    } catch (err) {
      alert("Failed to ban user");
    }
  };

  return (
    <div className="hall-container">
      <h1>🏆 Hall of Fame</h1>
      <div className="hall-grid">
        {users.length===0?<p className="error">We are waiting for you to join us !</p>:<table className="archive-table">
          <thead>
            <tr>
              <th>N°</th>
              <th>Name</th>
              <th>Nationality</th>
              <th >Score</th>
              <th className="irrelevent-responsive">Comb.</th>
              <th className="irrelevent-responsive">Geo.</th>
              <th className="irrelevent-responsive">Alg.</th>
              <th className="irrelevent-responsive">NT.</th>
              <th className="irrelevent-responsive">Joined the</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr key={index}>
                <td>#{(page - 1) * 10 + index + 1}</td>
                <td>
                  <a href={user.ViewProfileLink}>{user.username}</a>
                </td>
                <td>{user.nationality}</td>
                <td>
                  {user?.studentData.score.Algebra +
                    user?.studentData.score.Geometry +
                    user?.studentData.score.Combinatorics +
                    user?.studentData.score.NumberTheory}
                </td>
                <td className="irrelevent-responsive">{user?.studentData.score.Combinatorics}</td>
                <td className="irrelevent-responsive">{user?.studentData.score.Geometry}</td>
                <td className="irrelevent-responsive">{user?.studentData.score.Algebra}</td>
                <td className="irrelevent-responsive">{user?.studentData.score.NumberTheory}</td>
                <td className="irrelevent-responsive">{new Date(user?.createdAt).toLocaleDateString()}</td>
                <td style={{ position: "relative" }}>
                  <button
                    className="dots-btn"
                    onClick={() =>
                      setOpenMenuId(openMenuId === user._id ? null : user._id)
                    }
                  >
                    ⋮
                  </button>
                  {openMenuId === user._id && (
                    <div className="dropdown-menu" ref={menuRef}>
                      <button onClick={() => navigate('/Report')}>🚩 Report</button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>}
      </div>

      {/* Pagination */}
      <div className="pagination">
        <button
          onClick={() => setPage((p) => Math.max(p - 1, 1))}
          disabled={page === 1}
        >
          ⬅ Prev
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
          disabled={page === totalPages}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default HallOfFame;
